import { type ThemeConfig, type BaseTheme, type CssVariables, THEME_IDS } from './types';

const THEME_CONFIG = {
  DEFAULT: {
    id: THEME_IDS.DEFAULT_THEME,
    primaryColor: 'rgb(20, 143, 43)',
    gradient: 'linear-gradient(90deg, rgb(222, 221, 18) 3.053%, rgb(63, 224, 177) 207.743%, rgb(18, 157, 250) 400%)'
  },
  FIRST: {
    id: THEME_IDS.FIRST_THEME,
    primaryColor: 'rgb(162, 18, 94)',
    gradient: 'linear-gradient(90deg, rgb(82, 42, 93) 0%, rgb(170, 28, 97) 100%)',
    brandHover: 'rgb(227, 0, 102)',
    textBrand2: 'rgb(132, 15, 87)',
    overrides: {
      dark: {
        '--ds_textBrand2': 'rgba(255, 255, 255, 0.47)'
      }
    }
  },
  PREMIER: {
    id: THEME_IDS.PREMIER_THEME,
    primaryColor: 'rgb(5, 153, 111)',
    gradient: 'linear-gradient(270deg, rgb(130, 243, 169) 0.337%, rgb(9, 108, 122) 100%)',
    brandHover: 'rgb(50, 161, 145)',
    textBrand2: 'rgb(36, 87, 87)',
    overrides: {
      dark: {
        '--ds_textBrand2': 'rgba(255, 255, 255, 0.47)'
      }
    }
  }
} as const;

const createTheme = (config: ThemeConfig): BaseTheme => {
  const cssVariables: CssVariables = {
    '--progress-gradient': config.gradient,
    '--primary-color': config.primaryColor,
    '--ds_buttonBrandClick': config.primaryColor,
    '--ds_textBrand1': config.primaryColor,
    '--ds_radioOn': config.primaryColor,
    '--ds_checkboxOn': config.primaryColor,
    '--ds_chipsFillSelected': config.primaryColor,
    '--ds_buttonBrand': config.primaryColor
  };

  if (config.brandHover) {
    cssVariables['--ds_buttonBrandHover'] = config.brandHover;
    cssVariables['--ds_chipsFillSelectedHover'] = config.brandHover;
  }

  if (config.textBrand2) {
    cssVariables['--ds_textBrand2'] = config.textBrand2;
  }

  return {
    id: config.id,
    cssVariables,
    overrides: config.overrides
  };
};

export const THEMES = {
  DEFAULT: createTheme(THEME_CONFIG.DEFAULT),
  FIRST: createTheme(THEME_CONFIG.FIRST),
  PREMIER: createTheme(THEME_CONFIG.PREMIER)
} as const;

export type Theme = (typeof THEMES)[keyof typeof THEMES];
export type ThemeId = Theme['id'];
